/**
 * Class to define the marketing software features shown on some marketing pages.
 */
export class MarketingSoftwareFeature
{
    title: string;
    imageString: string;

    constructor(request) {
        this.title = request.title || '';
        this.imageString = request.imageString || '';
    }
}

/** Const containing the software features shown on several marketing pages.*/
export const MarketingFeatures: MarketingSoftwareFeature[] = [
    new MarketingSoftwareFeature({
        title: 'Simple & intuitive dashboard',
        imageString: '/assets/images/payhoa/condo-management-software/thumb-dash.png',
    }),
    new MarketingSoftwareFeature({
        title: 'Manager & member portal',
        imageString: '/assets/images/payhoa/condo-management-software/thumb-member.png',
    }),
    new MarketingSoftwareFeature({
        title: 'Automatically sending invoices',
        imageString: '/assets/images/payhoa/condo-management-software/thumb-check.png',
    }),
    new MarketingSoftwareFeature({
        title: 'Free online dues collecting',
        imageString: '/assets/images/payhoa/condo-management-software/thumb-fees.png',
    }),
    new MarketingSoftwareFeature({
        title: 'Autopay & scheduled payments',
        imageString: '/assets/images/payhoa/condo-management-software/thumb-autopay.png',
    }),
    new MarketingSoftwareFeature({
        title: 'Email & text communications',
        imageString: '/assets/images/payhoa/condo-management-software/thumb-messaging.png',
    }),
    new MarketingSoftwareFeature({
        title: 'Online maintenance requests',
        imageString: '/assets/images/payhoa/condo-management-software/thumb-tools.png',
    }),
    new MarketingSoftwareFeature({
        title: 'Bank reconciliation & sync',
        imageString: '/assets/images/payhoa/condo-management-software/thumb-bank.png',
    }),
    new MarketingSoftwareFeature({
        title: 'Document cloud storage & sharing',
        imageString: '/assets/images/payhoa/condo-management-software/thumb-cloud.png',
    }),
];
